/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 *
 * 2025
 * 29-09-2025
 * - [CHANGE] Unbind unnecessary events are gone
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_init = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Close the mobilemenu always on route
		 */
		specific_mobilemenu.toggle(1);

		/**
		 * Catch and active URL
		 */
		specific_interactions.catchAndActiveURL();

		/**
		 * Menu: Close
		 */
		specific_menubutton.close();

		/**
		 * specific_reviews_slideshow init
		 */
		specific_reviews_slideshow.onready();
		specific_dogs_slideshow.onready();

		/**
		 * Quick Menu hide on Intake page
		 */
		switch (
		url[2]
		) {

			default:
				$('.js-quick-menu').slideDown();
				$('.js-study-menu').removeClass('show');
				$('.js-study-menu-mobile').removeClass('mobile').hide();
				$('footer').show();
				break;

			/**
			 * Landingpages
			 */
			// case 'balans-herstellen':
			// 	$('.js-quick-menu').slideUp();
			// 	$('.js-study-menu-mobile').removeClass('mobile').hide();
			// 	$('footer').show();
			// 	break;

			/**
			 * Intake
			 */
			case 'intake':
				$('.js-quick-menu').slideUp();
				$('.js-study-menu').removeClass('show');
				$('.js-study-menu-mobile').removeClass('mobile').hide();
				$('footer').hide();

				/**
				 * Marketing: Send Click
				 * Catch the previous URL from history and send it to the server for marketing purposes
				 */
				specific_marketing.sendClick(
					'intake'
				);

				/*
				GTM Event: Intake geopend
				*/
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'intake_gestart'
				});

				break;

			/**
			 * Studie
			 */
			// case 'studie':

			// 	$('.js-quick-menu').slideUp();
			// 	$('.js-study-menu').addClass('show');
			// 	$('.js-study-menu-mobile').addClass('mobile').show();
			// 	$('footer').show();

			// 	break;

			/**
			 * Boek: Inleiding
			 */
			case 'boek':

				if (
					url[3] === 'inleiding'
				) {

					/**
					 * Marketing: Send Click
					 * Catch the previous URL from history and send it to the server for marketing purposes
					 */
					specific_marketing.sendClick(
						'book-inleiding'
					);

				}

				break;

		}

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_init);

